<template>
  <div>
    <Loader v-if="loading" :loading="loading" :absolute="true" />
    <div v-if="userInfo" class="row">
      <div class="col-12 col-sm-5 col-md-4">
        <div>
          <h2>ID: {{ userInfo.id }}</h2>

          <div>
            <b>ID 1C:</b>
            <v-text-field type="text" placeholder="Введите ID 1C" v-model="userInfo.ID_1C"></v-text-field>
                <v-btn
 
            color="red"
            text
            class="mb-2"
            style="max-width: 260px"
            @click="setId()"
            >Применить ID</v-btn
          >
          </div>
      
          <h3>{{ userInfo.title }}</h3>

              <v-checkbox
            @change="setStatus()"
            class="mt-1"
            v-model="userInfo.is_active"
            label="Активирован"
          ></v-checkbox>
          <h5>
            <b>Номер телефона:</b>
            {{ userInfo.phone_number }}
          </h5>
          <h5 v-if="userInfo.email">
            <b>Email:</b>
            <b>{{ userInfo.email }}</b>
          </h5>
          <!-- <h5>
            <b>Место в рейтинге:</b>
            {{userInfo.rate}}
          </h5> -->
          <h5>
            <b>Активация товаров:</b>
            {{ userInfo.count_activation }} шт.
          </h5>
          <h5>
            <b>Активных бонусов:</b>
            {{ userInfo.bonus_total | numberWithSpaces }} сум
          </h5>
          <h6 v-if="userInfo.activation_code">
            Код активации:
            <b>{{ userInfo.activation_code }}</b>
          </h6>
          <Br />
          <div v-if="$store.state.role[11]">
            <h3>Роль пользователя:</h3>
            <small>Есть две роли: партнер и субдистрибьютер.</small>
            <multiselect
              class="mt-3"
              v-model="roleSelected"
              :options="roles"
              :multiple="false"
              placeholder="Выберите"
              track-by="id"
              :loading="groupLoading"
              label="title"
              @input="setRole"
              @remove="removeRole"
            ></multiselect>
            <br />
          </div>
          <br />
          <div v-if="$store.state.role[11]">
            <h3>Группа:</h3>
            <small>Установка группы позволит пользователю получать дополнительный процент от активаций. В группе можно установить процент.</small>
            <multiselect
              class="mt-3"
              v-model="groupSelected"
              :options="groups"
              :multiple="false"
              placeholder="Выберите"
              track-by="id"
              :loading="groupLoading"
              label="title"
              @input="setGroup"
              @remove="removeGroup"
            ></multiselect>
            <br />
          </div>
          <div v-if="$store.state.role[8]">
            <h3>Установить связь с (парнером / дистрбьютером):</h3>
            <small>Если привязать пользователя, заказы это пользователя будут отправляться напрямую к приязанному пользователю</small>
            <multiselect
              v-model="userInfo.distributor"
              tag-placeholder="Введите номер"
              selectedLabel="Применен"
              placeholder="Поиск дистрибьютоеров"
              :showLabels="false"
              label="title"
              track-by="id"
              :loading="findLoading"
              :options="distrList"
              :taggable="true"
              :multiple="false"
              @search-change="asyncFindDistributors"
              @input="setDistributor"
            ></multiselect>
            <br />
          </div>
          <div v-if="$store.state.role[8]">
            <h3>Куратор:</h3>
        <small>Устанавливает отвественного администратора к данному пользователю</small>
            <multiselect
              v-model="userInfo.curator"
              tag-placeholder="Введите номер"
              selectedLabel="Применен"
              placeholder="Поиск админов"
              :showLabels="false"
              label="name"
              track-by="id"
              :loading="findLoading"
              :options="moderatorList"
              :taggable="false"
              :multiple="true"
              @search-change="asyncFind"
              @input="setCurator"
            ></multiselect>
            <br />
          </div>
          <v-btn
            v-if="0"
            color="green"
            text
            style="width: 45%; max-width: 200px"
            class="mb-5 mr-2"
            @click="goChat"
            >Начисление средств</v-btn
          >
          <br />
          <h5>
            <b>Дата регистрации в системе:</b>
            {{ userInfo.created_at | dateTime }}
          </h5>
          <h5>
            <b>Количество устройств:</b>
            {{ userInfo.devices.length }}
          </h5>
          <br />
        </div>
      </div>
      <div class="col-12 col-sm-7 col-md-8">
        <h3>Дополнительные настройки</h3>




        <v-btn
          color="warning"
          text
          class="mr-2"
          style="width: 45%; max-width: 200px"
          @click="goChat"
          >Открыть online чат</v-btn
        >
        <v-btn
          color="info"
          text
          class="mr-2"
          style="width: 45%; max-width: 200px"
          @click="downloadWithCSS"
          >Сертификат PDF</v-btn
        >
        <v-btn
          v-if="$store.state.role[1]"
          color="red"
          text
          style="width: 45%; max-width: 200px"
          @click="withDrawModal = true"
          >Вывод средств</v-btn
        >

        <v-checkbox
          @change="setStatus()"
          v-model="userInfo.show_reward"
          label="Показывать награду товара"
        ></v-checkbox>

        <v-checkbox
          @change="setStatus()"
          v-model="userInfo.show_conditional_price"
          label="Показывать стоиомсть товара"
        ></v-checkbox>

        <div v-if="userInfo.activation_code">
          <h4 class="mt-4">QR-CODE для активации</h4>
          <br />
          <img
            width="300"
            ref="qrCode"
            class="downloadQR"
            @click="
              download(
                'https://customerservice.uz/api/qr-code?code=' +
                  userInfo.activation_code
              )
            "
            :src="
              'https://customerservice.uz/api/qr-code?code=' +
              userInfo.activation_code
            "
            alt="qr code"
          />
        </div>
        <div>
          <h5>
            <b>Адрес:</b>
            {{ userInfo.addresses[0].title }}
          </h5>

          <label v-if="$store.state.role[9]">Изменить адрес</label>

          <v-layout v-if="$store.state.role[9]" wrap>
            <v-flex sm12 xs12 lg5 style="border: 5px solid transparent">
              <multiselect
                class="mt-3"
                v-model="regionSelected"
                :options="region"
                :multiple="false"
                placeholder="Выберите"
                track-by="id"
                :loading="addressLoading"
                label="title"
                @input="setRegion"
              >
                <span slot="noResult">Нет такой категории</span>
              </multiselect>
            </v-flex>

            <v-flex sm12 xs12 lg7 style="border: 5px solid transparent">
              <multiselect
                class="mt-3"
                v-model="citySelected"
                :options="city"
                :loading="addressLoading"
                :multiple="false"
                :disabled="!city.length"
                placeholder="Фильтр по городу (району)"
                track-by="id"
                label="title"
              >
                <span slot="noResult">Нет такой категории</span>
              </multiselect>
            </v-flex>

            <v-flex sm12 xs12 style="border: 5px solid transparent">
              <v-btn
                :disabled="!this.citySelected.id"
                @click="setAddress"
                color="red"
                text
                style="width: 100%; max-width: 200px"
                >Установить адрес</v-btn
              >
            </v-flex>
          </v-layout>

          <Br />
          <Br />
        </div>
        <div>
          <b>Торговая точка:</b>
          <v-text-field type="text" v-model="outlet"></v-text-field>
        </div>

        <div>
          <b>Номер магазина или адрес:</b>

          <v-text-field type="text" v-model="userInfo.mark"></v-text-field>
          <v-btn color="warning" text class="mb-5" @click="setMark"
            >Сохранить</v-btn
          >
        </div>
      </div>
    </div>
    <div style="position: fixed; left: -3133121px">
      <div class="pef" ref="pdf">
        <img class="pef-background" src="/img/cert-min.jpg" alt="doc" />
        <div v-if="userInfo.activation_code" class="code">
          {{ userInfo.activation_code }}
        </div>
        <div class="full_name">{{ userInfo.title }}</div>
        <div class="mark">{{ userInfo.mark }}</div>
      </div>
    </div>
    <v-dialog
      width="400"
      persistent
      transition="dialog-bottom-transition"
      v-model="withDrawModal"
    >
      <v-card>
        <Loader :loading="loadingCash" absolute="true" />
        <v-card-text>
          <h3>Вывод средств</h3>
          <b class="text-info">
            Доступно для вывода:
            <span class="user-link" @click="reward = userInfo.bonus_total"
              >{{ userInfo.bonus_total | numberWithSpaces }} сум</span
            >
          </b>
          <br />
          <div>
            <small v-if="can_reward >= 0"
              >У пользователя останется:
              {{ can_reward | numberWithSpaces }} сум</small
            >
            <b class="error--text" v-else
              >Вы указали слишком много для вывода</b
            >
          </div>
          <Br />
          <div class="body-2">Введите сколько вывести средств:</div>
          <v-text-field
            type="number"
            :max="userInfo.bonus_total"
            :min="0"
            v-model="reward"
          ></v-text-field>
          <v-btn
            v-bind:disabled="can_reward < 0 || reward <= 0"
            color="red"
            text
            class="mb-2"
            style="width: 100%"
            @click="setCash('withdraw')"
            >Вывести средства</v-btn
          >
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="text-xs-center">
          <v-btn
            color="primary"
            text
            style="width: 100%"
            @click="withDrawModal = false"
            >Отмена</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Loader from "../../helper/Loader";
import { mapMutations, mapState } from "vuex";

import jsPDF from "jspdf";

export default {
  components: { Loader },
  data: () => ({
    roles: [
      {
        id: 1,
        title: "Продавец",
      },
      {
        id: 2,
        title: "Субдистрибьютор",
      },
      {
        id: 3,
        title: "Партнер",
      },
    ],
    //Groups
    groupSelected: null,
    groups: [],
    groupLoading: true,
    //end Groups
    //Roles
    roleSelected: null,
    region: [],
    city: [],
    regionSelected: {},
    citySelected: {},
    addressLoading: true,
    loading: true,
    userInfo: null,
    img: null,
    outlet: "",
    outlet_id: null,
    qrCodeBase64: null,
    withDrawModal: false,
    depositModal: false,
    loadingCash: false,
    reward: null,
    findLoading: true,
    moderatorList: [],
    distrList: [],
  }),
  created() {
    this.getRegion();
    this.getGroups();
    setTimeout(() => {
      this.getUser();
    }, 200);
  },
  props: ["user"],
  methods: {
    ...mapMutations(["SET_USER"]),
    setCurator(val) {
      axios
        .post("admin/dealer/set-curator", {
          dealer_id: this.userInfo.id,
          curator: val,
        })
        .then((response) => {
          this.$toast.success({
            title: "Успешно",
            message: "Вы установили куратора к дилеру",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Ошибка",
            message: "Нельзя добавить куратора к дилеру",
          });
        });
    },
    asyncFind(query) {
      this.findLoading = true;
      axios
        .get("admin/administrators/list", {
          params: {
            search: query,
          },
        })
        .then((response) => {
          this.moderatorList = response.data.data;
        })
        .finally(() => {
          setTimeout(() => {
            this.findLoading = false;
          }, 400);
        });
    },
    asyncFindDistributors(query) {
      this.findLoading = true;
      axios
        .get("admin/users/list", {
          params: {
            search: query,
          },
        })
        .then((response) => {
          this.distrList = response.data.data;
        })
        .finally(() => {
          setTimeout(() => {
            this.findLoading = false;
          }, 400);
        });
    },
    getList(query) {
      this.findLoading = true;
      axios
        .get("admin/administrators/list")
        .then((response) => {
          this.moderatorList = response.data.data;
        })
        .finally(() => {
          setTimeout(() => {
            this.findLoading = false;
          }, 400);
        });
    },
    setMark() {
      this.loading = true;
      axios
        .post("admin/dealers/set-mark", {
          dealer_id: this.userInfo.id,
          mark: this.userInfo.mark,
          outlet: this.outlet,
          outlet_id: this.outlet_id,
          location_id: this.userInfo.addresses.length
            ? this.userInfo.addresses[0].id
            : null,
        })
        .then((response) => {
          this.$toast.success({
            title: "Торговая точка и адрес",
            message: "Успешно изменено",
          });
        })
        .catch((error) => {
          let data = error.response.data;
          if (data.errors) {
            Object.keys(data.errors).forEach((item) => {
              let err = data.errors[item];
              for (let i = 0; i < err.length; i++) {
                this.$toast.error({
                  title: "Ошибка",
                  message: err[i],
                });
              }
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setAddress() {
      this.loading = true;
      axios
        .post("admin/dealer/set-address", {
          dealer_id: this.userInfo.id,
          location_id: this.citySelected.id,
        })
        .then((response) => {
          this.$toast.success({
            title: "Адрес дилера",
            message: "Статус изменен",
          });
        })
        .catch((error) => {
          this.$toast.error({
            title: "Адрес дилера",
            message: "Ошибка на сервере",
          });
        })
        .finally(() => {
          this.getUser();
          this.loading = false;
        });
    },
    getGroups() {
      axios
        .get("admin/group/list/all")
        .then((response) => {
          this.groups = response.data;
        })
        .catch((error) => {})
        .finally(() => {
          this.groupLoading = false;
        });
    },
   
   
    removeGroup() {
      this.setGroup();
    },
    setGroup() {
      if (this.groupSelected) {
        this.groupSelected["dealer_id"] = this.userInfo.id;
      } else {
        this.groupSelected = {
          dealer_id: this.userInfo.id,
          id: null,
        };
      }
      axios
        .post("admin/dealer/set-group", this.groupSelected)
        .then((response) => {
          this.$toast.success({
            title: "Группы",
            message: "Изменили группу",
          });
        })
        .catch((error) => {
          this.$toast.error({
            title: "Активность диллера",
            message: "Ошибка на сервере",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    removeRole() {
      this.setRole();
    },
    setRole() {
      if (this.roleSelected) {
        this.roleSelected["dealer_id"] = this.userInfo.id;
      } else {
        this.roleSelected = {
          dealer_id: this.userInfo.id,
          id: null,
        };
      }
      axios
        .post("admin/dealer/set-role", this.roleSelected)
        .then((response) => {
          this.$toast.success({
            title: "Роль",
            message: "Изменили роль",
          });
        })
        .catch((error) => {
          this.$toast.error({
            title: "Активность диллера",
            message: "Ошибка на сервере",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    removeDistributor() {
      this.setDistributor();
    },
   
   setDistributor(val) {
      axios
        .post("admin/dealer/set-distribution", {
          dealer_id: this.userInfo.id,
          id: (val) ? val.id : null,
        })
        .then((response) => {
          this.$toast.success({
            title: "Дистрибьютер установлен",
            message: "Вы установили дистрибьютера",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Ошибка",
            message: "Нельзя добавить дистрибьютера к дилеру",
          });
        });
    },

    getUser() {
      this.loading = true;
      axios
        .get("admin/dealer/" + this.userID)
        .then((response) => {
          this.userInfo = response.data;
          this.getList();
        })
        .catch((error) => {
          alert("Пользователь удален");
        })
        .finally(() => {
          if (this.userInfo.outlet.length) {
            this.outlet = this.userInfo.outlet[0].title;
            this.outlet_id = this.userInfo.outlet[0].id;
          }
          if (this.userInfo.group) {
            this.groupSelected = this.userInfo.group;
          }

          if (this.userInfo.role) {
            this.roleSelected = this.userInfo.role;
          }
         

          this.loading = false;
        });
    },
    goChat() {
      this.SET_USER(null);
      this.$router.push({
        path: "feedback",
        query: { dealer_id: this.userInfo.id },
      });
    },
    download(doc) {
      window.open(doc);
    },
    setStatus() {
      this.loading = true;
      axios
        .post("admin/dealers/status", {
          dealer_id: this.userInfo.id,
          is_active: this.userInfo.is_active,
          show_reward: this.userInfo.show_reward,
          show_conditional_price: this.userInfo.show_conditional_price,
        })
        .then((response) => {
          this.$toast.success({
            title: "Активность диллера",
            message: "Статус изменен",
          });
        })
        .catch((error) => {
          this.$toast.error({
            title: "Активность диллера",
            message: "Ошибка на сервере",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setId() {
      this.loading = true;
      axios
        .post("admin/dealer/set-id", {
          ID_1C: this.userInfo.ID_1C,
          dealer_id: this.userInfo.id
        })
        .then((response) => {
          this.$toast.success({
            title: "USER ID 1C",
            message: "ID изменен",
          });
        })
        .catch((error) => {
          this.$toast.error({
            title: "Активность диллера",
            message: "Ошибка на сервере",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setCash(type) {
      this.loadingCash = true;
      axios
        .post("admin/activations/cash/" + type, {
          dealer_id: this.userInfo.id,
          reward: this.reward,
        })
        .then((response) => {
          this.$toast.success({
            title: "Вывод средств",
            message: "Средства успешно выведены",
          });
          //this.getUser();
          this.depositModal = this.withDrawModal = false;
          this.reward = null;
        })
        .catch((error) => {
          let data = error.response.data;
          if (data.errors) {
            let k = 0;
            Object.keys(data.errors).forEach((item) => {
              let err = data.errors[item];
              k++;
              for (let i = 0; i < err.length; i++) {
                setTimeout(() => {
                  this.$toast.error({
                    title: "Ошибка",
                    message: err[i],
                  });
                }, 100 * k);
              }
            });
          }
        })
        .finally(() => {
          this.loadingCash = false;
        });
    },
    getRegion() {
      axios
        .get("admin/locations/list", {
          params: {},
        })
        .then((response) => {
          this.region = response.data;
        })
        .catch((error) => {})
        .finally(() => {
          this.addressLoading = false;
        });
    },
    setRegion() {
      this.addressLoading = true;
      this.city = [];
      this.citySelected = {};
      axios
        .get("admin/locations/list", {
          params: {
            region: this.regionSelected.id ? this.regionSelected.id : null,
            is_city: 1,
          },
        })
        .then((response) => {
          console.log(this.city);
          this.city = response.data;
        })
        .catch((error) => {})
        .finally(() => {
          this.addressLoading = false;
        });
    },

    async downloadWithCSS() {
      this.loading = true;

      const doc = new jsPDF();

      const image2base64 = require("image-to-base64");

      if (this.userInfo && this.userInfo.activation_code)
        image2base64(
          "https://customerservice.uz/api/qr-code?code=" +
            this.userInfo.activation_code
        )
          .then((response) => {
            if (this.userInfo && this.userInfo.activation_code) {
              this.qrCodeBase64 = "data:image/png;base64," + response;
            }
          })
          .catch((error) => {
            console.log(error);
          });

      /** WITH CSS */

      const el = this.$refs.pdf;
      // add option type to get the image version
      // if not provided the promise will return
      // the canvas.
      const options = {
        type: "dataURL",
        width: 1330,
        height: 1881,
      };

      this.output = await this.$html2canvas(el, options);

      if (this.output && this.qrCodeBase64) {
        doc.addImage(this.output, "JPEG", 0, 0, 210, 297);
        doc.addImage(this.qrCodeBase64, "JPEG", 32, 198.6, 44, 44);
        doc.save(this.userInfo.id + "_cert.pdf");

        setTimeout(() => {
          this.loading = false;
        }, 4000);
      }
    },
  },
  computed: {
    ...mapState(["badge"]),

    userID: {
      get() {
        return this.user;
      },
    },
    imageUrl: {
      get() {},
    },
    can_reward: {
      get() {
        return this.userInfo.bonus_total - this.reward;
      },
    },
  },
  watch: {
   
  },
};
</script>

<style>
.pef {
  letter-spacing: 0.01px;
  width: 1330px;
  height: 1881px;
  position: relative;
  overflow: hidden;
  background: transparent;
}

.pef img.pef-background {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.pef img.qr-code {
  position: absolute;
  z-index: 1;
  width: 280px;
  height: 280px;
  -o-object-fit: cover;
  object-fit: cover;
  left: 193px;
  bottom: 341px;
  font-weight: 400;
}

.pef .code {
  position: absolute;
  z-index: 1;
  line-height: 100px;
  -o-object-fit: cover;
  object-fit: cover;
  font-size: 60px;
  top: 1276px;
  left: 818px;
}

.pef .full_name {
  left: 304px;
  line-height: 36px;
  max-width: 640px;
  word-break: break-word;
  top: 846px;
  font-size: 36px;
  font-weight: 400;
  font-family: Arial, sans-serif !important;
  position: absolute;
  /* font-style: italic; */
  z-index: 1;
}

.pef .mark {
  left: 496px;
  line-height: 36px;
  max-width: 559px;
  word-break: break-word;
  top: 974px;
  font-size: 36px;
  font-weight: 400;
  font-family: Arial, sans-serif !important;
  position: absolute;
  /* font-style: italic; */
  z-index: 1;
}
</style>
